const baseURL = 'https://almacenfresh.appboutique.click/';

export default baseURL;
